import { stylesheet } from 'astroturf';
import styled from 'astroturf/react';
import Button from 'src/components/Button';
import { Popup } from 'src/components/Popup';
import Svg from 'src/components/Svg';

const Container = styled('div')`
  height: auto;
`;

const PopupComponent = styled(Popup)`
  height: 80vh;
`;

const PopupInner = styled('div')`
  max-height: 18rem;
`;

const PopupFooter = styled('div')`
  position: absolute;
  bottom: 1rem;
  width: 90%;
  align-content: space-evenly;
`;

const PopupFooterActionBar = styled('div')`
  display: flex;
  align-content: space-evenly;
  align-items: center;
  justify-content: space-between;
`;

const LinkButton = styled(Button)`
  border-bottom: 0 !important;
`;

const ExistingQuestionsSection = styled('section')`
  width: 100%;
  margin: 0.5em 0 2em 0;
  max-height: 14rem;
  overflow-x: auto;
  border-radius: 1%;

  & div:not(:last-child) {
    border-bottom: var(--ph-gray-900) solid 1px;
  }
`;

const ExistingQuestionWrapper = styled('div')`
  display: flex;
  align-items: center;
  padding: 0.5rem;
`;

const ExistingQuestionNumber = styled('p')`
  align-self: start;
  font-size: var(--ph-text-sm);
  color: var(--ph-gray-500);
  margin: 0.5em 0;
`;

const ExistingQuestionText = styled('p')`
  font-size: var(--ph-text-sm);
  color: var(--ph-gray-500);
  margin: 0.5em 0.5em 0.5em 0;
  flex: 1 0;
`;

const ExistingQuestionRemoveIcon = styled(Svg)`
  cursor: pointer;
  width: 0.8em;

  & path,
  polyline {
    stroke: var(--black);
  }
`;

const Classes = stylesheet`
  .btn-save-and-apply:active {
    color: var(--ph-orange-500);
    background-color: var(--white);
  }

  .btn-save-and-apply[class*="disabled"] {
    color: var(--white);
    background-color: var(--ph-gray-300);
  }

  .remove-question-text {
    text-decoration: line-through;
    text-decoration-color: var(--ph-red-500);
  }
`;

export default {
  Classes,
  Container,
  ExistingQuestionNumber,
  ExistingQuestionRemoveIcon,
  ExistingQuestionsSection,
  ExistingQuestionText,
  ExistingQuestionWrapper,
  LinkButton,
  PopupInner,
  PopupComponent,
  PopupFooter,
  PopupFooterActionBar
};
